export default "__VITE_ASSET__e977b00d__"